/**
 * Build a {@link TraceContextExtractor} from an OpenTelemetry API object.
 *
 * The extractor injects the active context into a fresh carrier on every
 * call and returns the W3C trace headers found there, or null when there is
 * no active trace (no `traceparent`) or the API throws.
 */
export function createTraceContextExtractor(otel) {
    return () => {
        try {
            const carrier = {};
            otel.propagation.inject(otel.context.active(), carrier);
            const traceparent = carrier['traceparent'];
            if (!traceparent) {
                return null;
            }
            return {
                traceparent,
                tracestate: carrier['tracestate'],
                baggage: carrier['baggage'],
            };
        }
        catch (_a) {
            return null;
        }
    };
}
//# sourceMappingURL=create-extractor.js.map